<template>
  <div class="seckill-sketch">
    <div class="title">
      活动详情示意
      <span v-if="data.skuItems && data.skuItems.length" class="bangsToggle"> <el-switch v-model="isBangsShow" active-color="#3e6ef7" inactive-color="#f5f5f5" />刘海屏 </span>
    </div>
    <div v-if="data.skuItems && data.skuItems.length" class="block finalPage">
      <div v-if="isBangsShow" class="bangs" />
      <div class="blockContent">
        <img :src="data.productImage" alt="" class="img" />
        <div class="group-tip">
          <span class="group-price-text">拼团价</span>
          <span class="group-price">
            <span class="font-size-8">￥<span class="font-size-18">XXX</span><span class="font-size-8 r-pl-8 font-strike">￥{{ data.productOriginPrice || "XXX" }}</span></span>
          </span>
          <span class="group-num"> {{ data.groupNum || "X" }}人拼 </span>
          <span class="group-time"> 距离结束X天XX小时 </span>
        </div>
      </div>
      <div class="pro-name">
        XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
        <div class="absolute top-14 right-6 text-grey-15 center font-size-8">
          <i class="iconfont iconzhibohuodongyefenxiang" />
          <br />
          <span>分享</span>
        </div>
      </div>
      <hr style="border: 6px solid #f2f2f2" />
      <div class="fast-group">
        <span class="fast-group-num"><span class="redText">*&nbsp;</span>人在拼单,可直接参与</span>
        <span class="group-header">
          <i class="iconfont iconmorentouxiang font-size-36 text-purple-15" />
          <span class="relative-position bottom-8 left-4">***</span>
        </span>
        <span class="fast-info">
          <span class="inline-block vertical-middle">
            <span class="r-px-4 r-py-0">还差<span class="redText">*&nbsp;人</span>拼成</span>
            <br />
            <span class="text-grey-15">剩余XX:XX:XX</span>
          </span>
          <span class="gropu-join">去拼单</span>
        </span>
      </div>
      <hr style="border: 6px solid #f2f2f2" />
      <div class="pro-info">
        <div class="pro-sku">
          <div class="title">
            选择
          </div>
          <div style="flex-grow: 2">
            &nbsp;&nbsp;请选择 尺寸
          </div>
          <div class="more">
            <i class="iconfont icongengduo" />
          </div>
        </div>
        <div class="pro-sku r-mt-12">
          <div class="title">
            参数
          </div>
          <div style="flex-grow: 2">
            &nbsp;&nbsp;品牌 型号...
          </div>
          <div class="more">
            <i class="iconfont icongengduo" />
          </div>
        </div>
      </div>
      <hr style="border: 6px solid #f2f2f2" />
      <div class="blockContent">
        <img
          v-for="(item, index) in data.productImages" :key="index" :src="item"
          alt="" class="img"
        />
      </div>
      <div class="bottomBar">
        <div class="tools-button">
          <div>
            <i class="iconfont iconhuishouye" />
            <p>首页</p>
          </div>
          <div>
            <i class="iconfont iconlianxidaogou" />
            <p>客服</p>
          </div>
        </div>
        <div class="buy-button">
          <div class="maverick-buy">
            单独购买
            <p class="absolute bottom-0 left-5">
              ￥XXX.XX
            </p>
          </div>
          <div class="gropu-buy">
            我要开团
          </div>
        </div>
      </div>
    </div>
    <div v-else class="default-show" />
  </div>
</template>

<script>
import { toDecimal2 } from '@/util';

export default {
  props: ['data'],
  data() {
    return {
      isBangsShow: false,
    };
  },
  methods: {
    getMiniValue(item, key) {
      if (item.skuItems && item.skuItems.length) {
        const price = item.skuItems.map((i) => {
          return +i[key];
        });
        return toDecimal2(Math.min.apply(Math, price)) || '0';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.seckill-sketch {
  position: relative;
  .title {
    display: flex;
    justify-content: space-between;

    line-height: 30px;
  }

  .default-show {
    height: 210px;
    background-color: #f5f5f5;
    overflow: hidden;
  }

  .finalPage {
    height: 600px;
    overflow-y: auto;
    > .bangs {
      width: 200px;
      height: 30px;
      background: url(../../../../static/img/phoneHead.png) no-repeat center #060606;
      background-size: 100px;
      border-radius: 0 0 20px 20px;
      position: absolute;
      top: 30px;
      left: calc(50% - 100px);
      z-index: 5;
    }
    .img {
      width: 100%;
    }

    .group-tip {
      background-image: url("https://ssl-picture.tenyun.runsasoft.com/pingtuanditu.jpg");
      background-size: 100% 100%;
      background-position: center;
      height: 64px;
      width: 100%;
      position: relative;
      color: #ffffff;
      .group-price-text {
        position: absolute;
        top: 8px;
        left: 10px;
        font-size: 8px;
        color: #ffffff;
      }
      .group-price {
        position: absolute;
        bottom: 5px;
        left: 10px;
        font-size: 24px;
      }
      .group-num {
        position: absolute;
        top: 8px;
        right: 10px;
        padding: 2px 12px;
        border: 1px solid #ffffff;
        border-radius: 4px;
        font-size: 14px;
        color: #ffffff;
      }
      .group-time {
        position: absolute;
        bottom: 10px;
        right: 10px;
        font-size: 8px;
        color: #ffffff;
      }
    }

    .pro-name {
      position: relative;
      padding: 12px 48px 12px 12px;
      background: #ffffff;
      font-size: 14px;
      color: #000000;
      word-break: break-all;
    }
    .fast-group {
      height: 100px;
      position: relative;
      .group-header {
        position: absolute;
        left: 10px;
        bottom: 12px;
        line-height: 36px;
      }
      .fast-group-num {
        position: absolute;
        top: 16px;
        left: 12px;
        font-size: 12px;
      }
      .fast-info {
        position: absolute;
        bottom: 14px;
        right: 10px;
      }
      .gropu-join {
        padding: 6px 14px;
        border-radius: 16px;
        background: #fcca00;
        font-size: 8px;
        vertical-align: middle;
        display: inline-block;
      }
    }
    .pro-info {
      padding: 12px;
      font-size: 12px;
      .pro-sku {
        display: flex;
        line-height: 30px;
        justify-content: space-between;
        .title,
        .more {
          color: #999999;
          .iconfont {
            font-size: 12px;
          }
        }
      }
    }
    .bottomBar {
      box-shadow: 0 0 24px rgba(0, 0, 0, 0.08);
      padding: 12px;
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      align-items: center;
      .tools-button {
        line-height: 32px;
        display: flex;
        justify-content: space-between;
        width: 24%;
        color: #999999;
        text-align: center;
        p {
          line-height: 14px;
        }
      }
      .iconfont {
        font-size: 20px;
        color: #999999;
      }
      .buy-button {
        color: #ffffff;
        display: flex;
        font-size: 14px;
        border-radius: 36px;
        overflow: hidden;
        height: 36px;
        line-height: 36px;
        width: 160px;
        .maverick-buy {
          position: relative;
          background: #595959;
          font-size: 8px;
          text-align: center;
          line-height: 20px;
        }
        .gropu-buy {
          background: #ff4444;
          text-align: center;
        }
        div {
          flex-grow: 1;
        }
      }
    }
  }
}
</style>
